export default __webpack_public_path__ + "static/logo-bc2cb10b84bccf2b22a27c04ceefca5d.svg";